import React, { useMemo } from 'react';
import { Tooltip } from 'antd';

const DayCell = React.memo(({ status, events, date, onClick }) => {
	const dotClass =
		status === 'AVAILABLE' ? 'green' : status === 'PARTIALLY_AVAILABLE' ? 'yellow' : 'red';

	const label = useMemo(() => {
		if (!events || events.length === 0) return '';
		if (status === 'BUSY') return 'Full Day';
		if (status === 'PARTIALLY_AVAILABLE') {
			if (events.length === 1) {
				const e = events[0];
				if (e.reportingTime) return e.reportingTime;
				if (e.eventTime && e.eventTime !== 'Full Day') return e.eventTime;
			}
			return `${events.length} event${events.length > 1 ? 's' : ''}`;
		}
		return '';
	}, [events, status]);

	const tooltipContent = useMemo(() => {
		if (!events || events.length === 0) return null;
		return (
			<div>
				{events.map((e, i) => {
					const timeDisplay = e.reportingTime || e.eventTime || 'Time TBD';
					const durationDisplay = e.durationInHrs ? `${e.durationInHrs}hrs` : null;
					return (
						<div key={i} className="day-cell-tooltip-event">
							<div>
								{e.workspaceId && <span>{e.workspaceId} - </span>}
								{e.projectTitle && <span>{e.projectTitle} - </span>}
								<strong>{e.eventName || 'Untitled'}</strong>
							</div>
							<div>
								{timeDisplay}
								{durationDisplay && ` • ${durationDisplay}`}
								{e.city && ` • ${e.city}`}
							</div>
						</div>
					);
				})}
			</div>
		);
	}, [events]);

	return (
		<Tooltip title={tooltipContent} placement="top">
			<div className={`day-cell day-cell-${dotClass}`} onClick={onClick}>
				<span className={`day-cell-dot ${dotClass}`} />
				<span className="day-cell-label">{label}</span>
			</div>
		</Tooltip>
	);
});

export default DayCell;
